export enum KnmErpStatusCodesEnum {
  TYPE_NEW = 'TYPE_NEW',
  TYPE_SYSP_APPROVE = 'TYPE_SYSP_APPROVE',
  TYPE_NEED_DO_OVER_AGAIN = 'TYPE_NEED_DO_OVER_AGAIN',
  TYPE_DISAPPROVED = 'TYPE_DISAPPROVED',
  TYPE_WAITING_CARRY_OUT = 'TYPE_WAITING_CARRY_OUT',
  TYPE_CARRIED_OUT = 'TYPE_CARRIED_OUT',
  TYPE_COMPLETED = 'TYPE_COMPLETED',
  TYPE_CANT_BE_CARRY_OUT = 'TYPE_CANT_BE_CARRY_OUT',
  TYPE_APPEALED = 'TYPE_APPEALED',
  TYPE_DELETED = 'TYPE_DELETED',
  TYPE_ERKNM_CLOSED = 'TYPE_ERKNM_CLOSED',
}
